var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAvailability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0581,
    cy: 40.3167,
    r: 40.3167,
    fill: "#CB8152"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5192 30.9722V23.75M47.9637 30.9722V23.75M28.1026 56.25H53.3803C55.3747 56.25 56.9915 54.6333 56.9915 52.6389V30.9722C56.9915 28.9779 55.3747 27.3611 53.3803 27.3611H28.1026C26.1082 27.3611 24.4915 28.9779 24.4915 30.9722V52.6389C24.4915 54.6333 26.1082 56.25 28.1026 56.25Z",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5279_54203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.054 48.6875L46.429 37.3125M35.054 37.3125L46.429 48.6875",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5279_54203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(33.7415 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvailability);
export default __webpack_public_path__ + "static/media/no-availability.03f05406b09de3c273a7d5a8657ce27a.svg";
export { ForwardRef as ReactComponent };